import React from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const TarjetaVoto = (props) => {
  const { voto } = props;

  console.log("Estado inicial:", voto.nombre, voto.anulado);

  const anular = async () => {
    Swal.fire({
      title: "Anulación de Voto",
      html: `<input type="text" id="razon" class="swal2-input" placeholder="Razón por la que se anula el voto.">`,
      confirmButtonText: "Anular",
      focusConfirm: false,
      preConfirm: () => {
        const razon = Swal.getPopup().querySelector("#razon").value;
        if (!razon) {
          Swal.showValidationMessage(
            `Escribir la razón por la cual se anula el voto`
          );
        }
        return { razon };
      },
    }).then((result) => {
      axios
        .put(`/api/votos/anular/${voto.municipioId}/${voto._id}`, {
          propuestaId: voto.propuestaId,
          razonAnulado: result.value.razon,
        })
        .then((res) => {
          Swal.fire(res.data.mensaje, "", "success");
          // Notifica al componente padre para actualizar el prop `voto`
          if (props.onAnular) {
            props.onAnular(voto._id, result.value.razon);
          }
        })
        .catch((err) => {
          Swal.fire(err.message || "Error al anular el voto", "", "error");
        });
    });
  };

  const observaciones = (voto) => {
    const { emailRepetido, enPadron, inconsistencia } = voto.control;
    let obs = "";
    if (!enPadron) obs += "No se encuentra en el padrón. ";
    if (inconsistencia) obs += "Uno o más datos no coinciden con el padrón. ";
    if (emailRepetido) obs += "// Email Repetido. ";
    if (!obs) obs = "No se registran anomalías.";
    return obs;
  };

  return (
    <div className="card tarjeta-voto">
      <div className="card-header">
        DNI: {voto.dni} {" // "} Propuesta Elegida: {voto.propuestaTitulo}
        {voto.anulado && (
          <b style={{ color: "red" }}>
            {" // "} ANULADO: {voto.razonAnulado}
          </b>
        )}
      </div>
      <div className="card-body">
        <p>
          <b>Nombre</b>: {voto.nombre}
          {voto.pNombre && (
            <small>
              <b> en padrón: {voto.pNombre}</b>
            </small>
          )}
        </p>
        <p>
          <b>Fecha Nacimiento</b>: {voto.fechaNac}
          {voto.pClase && (
            <small>
              <b> en padrón: {voto.pClase}</b>
            </small>
          )}
        </p>
        <p>
          <b>Dirección</b>: {voto.dir}
          {voto.pDir && (
            <small>
              <b> en padrón: {voto.pDir}</b>
            </small>
          )}
        </p>
        <p>
          <b>Email</b>: {voto.email}
        </p>
        <p>
          <b>Teléfono</b>: {voto.tel}
        </p>

        <div className="card-body text-right m-1 p-0">
          {!voto.anulado && (
            <button className="btn ppr-btn-rojo btn-sm" onClick={anular}>
              Anular
            </button>
          )}
        </div>
      </div>
      <div className="card-footer">{observaciones(voto)}</div>
    </div>
  );
};

export default withRouter(TarjetaVoto);
